import React, { Component } from 'react';
import DataTable from 'react-data-table-component';
import { Icon, Button, notification, Popconfirm } from 'utils/ui';
import { FaStickyNote } from 'react-icons/fa';
import AddPersonalNote from './AddPersonalNote';
import { deletePrivateNote } from '../api_calls/user';
import { observer } from 'mobx-react';

const customizeRenderEmpty = () => (
    <div style={{ textAlign: 'center', }}>
        <Icon type="smile" style={{ fontSize: 50 }} />
        <p>No Notes Found</p>
    </div>
);

@observer(['UserStore', 'AuthStore', 'FamilyStore'])
class MyNotes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            columns: [
                {
                    sortable: true,
                    name: 'About',
                    selector: 'about',
                },
                {
                    sortable: true,
                    name: 'Note',
                    selector: 'body',
                    grow: 2,
                },
                {
                    sortable: false,
                    name: 'Actions',
                    selector: 'actions',
                    cell: row => row.actions,
                }
            ]
        };
        this.tableData = this.tableData.bind(this);
        this.confirmDelete = this.confirmDelete.bind(this);
    }
    confirmDelete(note) {
        const { UserStore, AuthStore } = this.props;
        notification.open({
            message: 'Deleting your note',
            icon: <Icon type="loading" style={{ color: '#108ee9' }} />,
            duration: 1
        });

        console.log(note);
        let user = UserStore.childViewActive ? UserStore.activeChild.id : UserStore.user._id;
        deletePrivateNote(user, note.body, AuthStore.userAuth.auth.accessToken).then(() => {
            UserStore.refreshUser(AuthStore.userAuth.auth.accessToken);
        });
    }
    tableData() {
        const { UserStore, FamilyStore } = this.props;
        const getUserName = (userId) => {
            let person = FamilyStore.family.find(member => member._id === userId);
            return person ? person.name : (userId || "Nobody");
        };

        return UserStore.user.privateNotes.map((note, index) => {
            return {
                key: `${index}-${note.body || 'note'}`,
                body: note.body,
                about: getUserName(note.aboutPerson),
                actions: (
                    <div className="private-notes-table-actions">
                        <Popconfirm title="Are you sure delete this note?" okText="Yes" onConfirm={this.confirmDelete.bind(this, note)} cancelText="No">
                            <Button className="AppFont ui-btn-danger private-notes-table-btn" size="small">
                                <Icon type="delete" style={{ marginRight: 6 }} /> Delete
                            </Button>
                        </Popconfirm>
                    </div>
                )
            };
        });
    }

    render() {
        return (
            <div>
                <AddPersonalNote />
                <div style={{ top: '70px', position: 'relative' }}>
                    <div className="my-notes-info-banner" role="note" aria-label="Private notes notice">
                        <span className="my-notes-info-icon" aria-hidden="true"><FaStickyNote /></span>
                        <div className="my-notes-info-copy">
                            <div className="my-notes-info-title">Private Notes</div>
                            <div className="my-notes-info-text">Only you can view and manage these notes.</div>
                        </div>
                    </div>
                    <DataTable
                        defaultSortField="about"
                        defaultSortAsc={true}
                        columns={this.state.columns}
                        data={this.tableData()}
                        noDataComponent={customizeRenderEmpty()}
                    />
                </div>
            </div>
        );
    }
}

export default MyNotes;